<template>
  <span>{{ formattedPrefix }}{{ calculatedPrice }}{{ formattedSuffix }}</span>
</template>

<script>
export default {
    props: {
        price: {
            type: [Number, String],
            default: 0,
        },
        cart: {
            type: Boolean,
            default: false,
        },
        priceWithTax: {
            type: [Number, String],
            default: null,
        },
        priceWithoutTax: {
            type: [Number, String],
            default: null,
        },
        prefix: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
    },
    computed: {
        calculatedPrice() {
            if (this.hasCalculatedValues(this.priceWithTax, this.priceWithoutTax)) {
                return this.formatPriceFromCalculatedValues(
                    this.priceWithTax,
                    this.priceWithoutTax
                );
            } else if (this.price) {
                return this.formatPriceConditionallyWithVat(this.price, this.cart);
            } else {
                return this.$options.filters.formatPrice(0);
            }
        },
        formattedPrefix() {
            return this.prefix !== '' ? this.prefix.trim() + ' ' : this.prefix.trim();
        },
        formattedSuffix() {
            return this.suffix !== '' ? ' ' + this.suffix.trim() : this.suffix.trim();
        },
    },
    methods: {
        hasCalculatedValues: function (withTax, withoutTax) {
            return !!withTax && !!withoutTax;
        },
        formatPriceFromCalculatedValues: function (withTax, withoutTax) {
            const showPricesWithVat = this.$store.getters.showPricesWithVat;
            if (showPricesWithVat) {
                return this.$options.filters.formatPrice(withTax);
            }
            return this.$options.filters.formatPrice(withoutTax);
        },
        formatPriceConditionallyWithVat: function (price, cart = false) {
            price = this.parseCommaDecimalFormat(price);

            switch (this.priceAction(cart)) {
                case 'multiply':
                    price = price * this.$store.getters.getVatPercentage;
                    break;
                case 'divide':
                    price = price / this.$store.getters.getVatPercentage;
                    break;
                default:
                    break;
            }

            return this.$options.filters.formatPrice(price);
        },
        priceAction: function (cart) {
            const showPricesWithVat = this.$store.getters.showPricesWithVat;
            let includesTaxes = this.$store.getters.getProductIncludesTaxes;
            if (cart) {
                includesTaxes = this.$store.getters.getCartIncludesTaxes;
            }

            //prices don't include taxes && user wants to see those prices
            if (!includesTaxes && showPricesWithVat) {
                //multiply by 1.24
                return 'multiply';

                //prices include taxes && user wants to see prices without taxes
            } else if (includesTaxes && !showPricesWithVat) {
                //divide with 1.24
                return 'divide';
            }
            //prices include taxes and user wants too prices with taxes or
            //prices don't include taxes and user doesn't want to see prices with taxes
            return true;
        },
    },
};
</script>
